import Component from './DeviceOperatorMonitor.vue';

export default {
  install(Vue) {
    Vue.component('BkfDeviceOperatorMonitor', Component);
  },
};
